import { Component, inject, OnInit } from '@angular/core';
import { LoaderFullScreenService } from '@vueling-ng/vy-ds/src/lib/components/globals/loaders/loader-full-screen';
import { OneTrustService } from 'app/services/external/cookies/one-trust.service';
import { loaderPrimaryConfig } from '../model/languages-config';

@Component({
  selector: 'app-login',
  templateUrl: './auth.component.html'
})
export class AuthComponent implements OnInit {
  private readonly _loaderService = inject(LoaderFullScreenService);
  private readonly _oneTrustService = inject(OneTrustService);

  public ngOnInit(): void {
    this._loaderService.show(loaderPrimaryConfig);
    this._oneTrustService.cookieConsentGiven().subscribe(() => {
      this._loaderService.hide();
    });
  }
}
